import NewsItem from "./NewsItem";
import {useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import CommentsContainer from "./CommentsContainer";
import {useTitle} from "../useTitle";

function NewsPage() {
  const { newsId } = useParams();
  const newsItem = useSelector(state => state.homepage.newsItems[newsId]);

  useTitle('News');

  return (
    <div>
      <NewsItem newsItem={ newsItem } />
      <CommentsContainer newsId={ newsId } />
    </div>
  );
}

export default NewsPage;
